import { KYC_SUCCESS_STATUSES, TERMINAL_PROVIDER_STATUSES } from '#constants';

export function isKycProviderSucceeded(providerStatus?: string): boolean {
  return Boolean(providerStatus && KYC_SUCCESS_STATUSES.has(providerStatus));
}

export function isKycProviderTerminal(providerStatus?: string): boolean {
  return Boolean(providerStatus && TERMINAL_PROVIDER_STATUSES.has(providerStatus));
}
